export default "__VITE_ASSET__C65kdJeV__"